import { Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class SyncVendorEntity extends DexResourceModel {

    @Field(String)
    public vendor_uuid: string = '';
    @Field(String)
    public syncEntity_uuid: string = '';
    @Field(String)
    public name: string = '';
    @Field(Boolean)
    public syncIn: boolean = false;
    @Field(Boolean)
    public syncOut: boolean = false;
    @Field(Number)
    public syncFrequencyInMinutes: number = 0;
    @Field(Date)
    public lastSyncIn: Date = new Date();
    @Field(Date)
    public lastSyncOut: Date = new Date();

    constructor(data?: any) {
        super();
        this.mapData(data);
    }

    public get lastSyncInUTC(): Date | null{
        if(!this.lastSyncIn) return null;
        return this.pacificDateAsUTC(this.lastSyncIn);
    }

    public get lastSyncOutUTC(): Date | null{
        if(!this.lastSyncOut) return null;
        return this.pacificDateAsUTC(this.lastSyncOut);
    }

}
